import React, {useState} from 'react';
import defaultImage from './defaultImage.png'
import arrowImage from './arrow.png'

const User = () => {
	const [auth, setAuth] = useState(false)

	function handleUser() {
		if (auth === true) {
			setAuth((!auth))
			document.querySelector('.user-box').classList.add('trans-y')
			document.querySelector('.user-box__button').classList.remove('trans-rot')
		} else {
			setAuth((!auth))
			document.querySelector('.user-box').classList.remove('trans-y')
			document.querySelector('.user-box__button').classList.add('trans-rot')
		}
	}


	return (
		<div className='user-box trans-y' onClick={handleUser}>
			<div className='user-box__line'>
				<img className='user-box__image' alt='' src={defaultImage} />
				<span className=''>Damien</span>
				<button className='user-box__button' ><img alt='' src={arrowImage}/></button>
			</div>
			<div className='user-box__auth'>
				<span className='user-box__options'>Profile</span>
				<span className='user-box__options'>Log Out</span>
			</div>
		</div>

		)
}

export default User;